import CircleWithMinus from './circle-with-minus';

export * from './circle-with-minus';
export default CircleWithMinus;
